<template>
  <div class="table-op-col-bdr">
    <div class="balance_box">
      <div class="balance_content">
        <div class="f_14 c_bbb">未分配金额</div>
        <div
          class="clearfix"
          style="padding-bottom: 32px; border-bottom: 1px solid #e9e9e9"
        >
          <div class="f_l">
            <span class="c_red f_24">¥</span>
            <span class="c_red f_48">{{ unAssignAmountStr }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="" style="padding: 0 32px">
      <div
        style="
          padding: 15px;
          padding-top: 0;
          font-size: 16px;
          font-weight: 700;
          color: #333;
        "
      >
        分配金额明细
      </div>
      <el-table :data="assign.tab.table" style="width: 100%" height="380">
        <el-table-column prop="orgName" label="名称"> </el-table-column>
        <el-table-column prop="availMoney" label="可用金额（元）"> </el-table-column>
        <el-table-column prop="money" label="累计总额（元）">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-track="{ action: 'account_assignRec' }"
              size="small"
              type="text"
              @click="onAssignRecord(scope.row)"
              >查看</el-button
            >
            <el-button
              v-track="{ action: 'account_assign' }"
              v-if="show.Dispatch_Money"
              size="small"
              type="text"
              @click="onAssign(scope.row)"
              >调整金额</el-button
            >
            <el-button
                    v-track="{ action: 'account_assign' }"
                    v-if="show.Dispatch_Money"
                    size="small"
                    type="text"
                    @click="showFlowDetail(scope.row)"
            >流水明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onItems_currChange"
        :current-page="assign.tab.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="assign.tab.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      @closed="eclosedAssign"
      width="650px"
      title="分配金额"
      :visible.sync="assign.adjVisible"
    >
      <div class="cnt pos-rel">
        <el-form
          size="mini"
          ref="assginForm"
          class="newForm"
          :rules="assign.adjust.rules"
          :model="assign.adjust.form"
          label-width="140px"
          @validate="eValidate"
        >
          <el-form-item label="分配金额类型" prop="ship">
            <el-select
              v-model="assign.adjust.form.ship"
              placeholder="请选择调整关系"
            >
              <el-option label="调增" :value="1"></el-option>
              <el-option label="调减" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" prop="assignMoney">
            <el-input
            @input="limitNumber"
              placeholder="请输入金额"
              v-model.trim="assign.adjust.form.assignMoney"
            >
              <span slot="prefix" style="">￥</span>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="tips" v-show="assign.adjust.isValid">
          <span v-show="assign.adjust.form.ship == 1"
            >账户可分配金额 {{ unAssignAmountStr }} 元</span
          >
          <span v-show="assign.adjust.form.ship == 2"
            >项目可用金额 {{ assign.adjust.availMoney }}元</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="assign.adjVisible = false"
          >取 消</el-button
        >
        <el-button size="mini" type="danger" @click="onAssignConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      custom-class="assign-pop"
      :fullscreen="true"
      title="分配记录"
      :visible.sync="assign.listVisible"
    >
      <div class="cnt">
        <div style="padding: 15px 30px 40px 30px;background:#fff;    margin-bottom: 25px;box-shadow:0 0 15px #ccc;">
          <p class="pop-title">基础信息</p>
          <div class="flex">
            <div class="baseItem">
              <label>名称：</label>
              <span>{{ assign.tab.row && assign.tab.row.orgName }}</span>
            </div>
            <div class="baseItem">
              <label>可用金额（元）：</label>
              <span>{{  assign.tab.row && assign.tab.row.availMoney }}</span>
            </div>
            <div class="baseItem">
              <label>累计金额（元）：</label>
              <span>{{  assign.tab.row && assign.tab.row.money }}</span>
            </div>
          </div>
        </div>
        <div style="padding: 20px 30px;background:#fff;box-shadow:0 0 15px #ccc;">
          <p class="pop-title">操作日志</p>
          <el-table
            :data="assign.record.table"
            style="width: 100%"
            v-loading="assign.record.loading"
          >
            <el-table-column label="操作类型">
              <template slot-scope="scope">{{scope.row.type==1?'调增':'调减'}}</template>
            </el-table-column>
            <el-table-column prop="assignMoney" label="调整金额（元）"></el-table-column>
            <el-table-column prop="operator" label="操作人"></el-table-column>
            <el-table-column prop="createTm" label="操作时间"></el-table-column>
            <el-table-column prop="comment" label="备注"></el-table-column>
          </el-table>
          <el-pagination
            @current-change="onAssignRec_currChange"
            :current-page.sync="assign.record.pageNum"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="assign.record.total"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    let validateLimit = (rule, value, callback) => {
      let release = parseFloat(this.unAssignAmount);
      let adj = this.assign.adjust;
      let currItem = parseFloat(adj.availMoney);
      if (adj.form.ship == 1 && release < value) {
        callback(new Error("输入金额已超过账户可分配金额"));
      } else if (adj.form.ship == 2 && currItem < value) {
        callback(new Error("输入金额已超过可用金额"));
      } else {
        callback();
      }
    };
    return {
      show: {
        Dispatch_Money: false,
      },
      availMoney: "997,876.00",
      unAssignAmount: 0,
      unAssignAmountStr: 0,
      assign: {
        adjVisible: false,
        listVisible: false,
        tab: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          table: [],
          row:null,
        },
        record: {
          pageNum: 1,
          pageSize: 5,
          total: 0,
          table: [],
          loading: false,
        },
        adjust: {
          orgId:null,
          isValid: true,
          availMoney: 0,
          form: {
            ship: 1,
            assignMoney: "",
          },
          rules: {
            assignMoney: [
              { required: true, message: "请填写金额", trigger: "change" },
              { validator: validateLimit, trigger: "change" },
            ],
          },
        },
      },
    };
  },
  created() {
    let map = JSON.parse(sessionStorage.getItem("menuMap"));
    let submenuList = map["PlatformAccount"].split("-");
    submenuList.forEach((item, idex) => {
      this.show[item] = true;
      idex == 0 && (this.activeTab = item);
    });
  },
  mounted() {
    this.getAssignInfo();
    this.getItemList();
  },
  methods: {
    ...mapActions(["getItemListApi", "getAssignRecordListApi", "assignApi","assignInfoApi"]),
    limitNumber(val){
      let tpl = val.replace(/[^0-9.]/g,'')
      this.assign.adjust.form.assignMoney = tpl
    },
    getAssignInfo(){
      this.assignInfoApi().then(res=>{
        this.unAssignAmount = res.unAssignAmount
        this.unAssignAmountStr = res.unAssignAmountStr
      }).catch(e=>{})
    },
    tipsboxShow() {
      this.dialogTableVisible = true;
      this.recharge();
    },
    onAssignRecord(row) {
      this.assign.record.pageNum = 1;
      this.assign.listVisible = true;
      this.assign.tab.row = row;
      this.getAssignRecordList();
    },
    getItemList() {
      let params = {
        pageSize: 10,
        pageNum: this.assign.tab.pageNum,
      };
      this.getItemListApi(params)
        .then((res) => {
          this.assign.tab.table = res.rows;
          this.assign.tab.total = res.totalCount;
        })
        .catch((e) => {});
    },
    getAssignRecordList() {
      let params = {
        orgId:this.assign.tab.row.orgId,
        pageSize: 10,
        pageNum: this.assign.record.pageNum,
      };
      this.getAssignRecordListApi(params)
        .then((res) => {
          this.assign.record.table = res.rows;
          this.assign.record.total = res.totalCount;
        })
        .catch((e) => {});
    },
    onAssign(row) {
      this.assign.adjust.availMoney = (row.availMoney?row.availMoney:0);
      this.assign.adjust.orgId = row.orgId;
      this.assign.adjVisible = true;
    },
    showFlowDetail(row){
      window.sessionStorage.setItem('MoneyFlowDetailData',JSON.stringify(row))
      this.$router.push('/manage/FlowMoneyDetail')
    },
    onAssignConfirm() {
      this.$refs.assginForm.validate((valid) => {
        if (valid) {
          let money = parseFloat(this.assign.adjust.form.assignMoney);
          this.assignApi({ assignMoney: money ,type:this.assign.adjust.form.ship,orgId:this.assign.adjust.orgId})
            .then((res) => {
              this.$message({
                type: "success",
                message: "分配成功",
              });
              this.assign.adjVisible = false;
              this.getItemList();
              this.getAssignInfo();
            })
            .catch((e) => {});
        }
      });
    },
    eclosedAssign() {
      this.$refs.assginForm.resetFields();
    },
    onItems_currChange(val) {
      this.assign.tab.pageNum = val;
      this.getItemList();
    },
    onAssignRec_currChange(val) {
      this.assign.record.pageNum = val;
      this.getAssignRecordList();
    },

    queryAccountOverage() {
      fetchPost("/saas/bankAccountBind/queryAccountOverage", {}).then((res) => {
        this.overageAmount = res.overageAmountStr;
        this.freezeAmount = res.freezeAmountStr;
        this.availableMoney = res.availableMoneyStr;
      });
    },
    queryAccountFlow() {
      var data = {
        pageNum: this.currentPage,
        pageSize: 10,
        startTm: "",
        endTm: "",
      };
      if (this.dateVal && this.dateVal.length > 0) {
        data.startTm = this.dateVal[0];
        data.endTm = this.dateVal[1];
      }
      fetchPost("/saas/bankAccountBind/queryAccountFlow", data).then((res) => {
        this.tableData = res.list;
        this.total = res.total;
      });
    },
    eValidate(prop, isvalid) {
      this.assign.adjust.isValid = isvalid;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryAccountFlow();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex > 0) {
          if (rowIndex === 1) {
            return {
              rowspan: 4,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
      if (columnIndex === 1 || columnIndex > 2) {
        if (rowIndex > 0 && rowIndex < 3) {
          if (rowIndex === 1) {
            return {
              rowspan: 2,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.iAssign {
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 1px;
}
#app .account-tab /deep/ .el-tabs__nav-wrap::after {
  background-color: rgb(233, 233, 233);
}
.account-tab /deep/ .el-tabs__header.is-top {
  margin-bottom: 25px !important;
}
.account-tab.el-tabs--top /deep/ .el-tabs__item.is-top:nth-child(2) {
  padding-left: 0 !important;
}
.account-tab.el-tabs--top /deep/ .el-tabs__item.is-top:last-child {
  padding-right: 0 !important;
}
.el-date-editor--datetimerange.el-input__inner {
  width: 345px;
}
.m_b24 {
  margin-bottom: 16px !important;
}
.f_14 {
  font-size: 14px;
}
.f_16 {
  font-size: 16px;
}
.f_24 {
  font-size: 24px;
}
.f_32 {
  font-size: 32px;
  color: #2a2a2a;
  letter-spacing: 1.45px;
  line-height: 46px;
}
.f_48 {
  font-size: 48px;
  line-height: 68px;
  letter-spacing: 2.18px;
}
.c_bbb {
  color: #bbbbbb;
}
.c_red {
  color: #dc1e32;
}
.f_l {
  float: left;
}
.btn_box {
  margin-left: 70px !important;
  margin-top: 20px !important;
}
.availableBalance {
  padding-right: 120px !important;
  border-right: 1px solid #e9e9e9;
}
.freezeBalance {
  padding-left: 120px !important;
}
// .btn_box  .el-button{
//   background: #DC1E32;
//   color: #fff;
// }
.title_header {
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  color: #000000;
  padding-left: 56px !important;
  background: #fff;
  font-family: PingFangSC-Semibold;
}
.balance_box {
  background: #f1f1f1;
  .balance_content {
    /* height: 305px; */
    background: #fff;
    padding: 40px 32px 20px 32px !important;
    box-sizing: border-box;
    /* box-shadow: 0 -6px 20px 0 rgba(0, 0, 0, 0.15); */
  }
}
.detail_box {
  background: #f1f1f1;
  padding-top: 10px !important;
  .detail_content {
    height: 466px;
    background: #fff;
    padding: 24px 32px !important;
    box-sizing: border-box;
    .tab_box {
      margin-top: 30px !important;
      position: relative;
      .date_box {
        position: absolute;
        right: 50px;
        top: -9px;
        z-index: 1001;
      }
    }
  }
}
/deep/.el-tabs__item.is-active {
  color: #dc1e32 !important;
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.clearfix:after {
  *zoom: 1;
  /*针对IE6/IE7*/
}

.el-table {
  /deep/tbody tr:hover > td {
    background-color: white;
  }
}
#app .el-form-item--mini.el-form-item {
  margin-bottom: 20px;
}
#app .newForm {
  padding: 20px 0 !important;
}
#app .newForm /deep/ .el-form-item__content {
  width: 435px;
}
#app .newForm /deep/ .el-input--mini .el-input__inner {
  width: 435px;
}
.tips {
  position: absolute;
  left: 140px;
  bottom: 15px;
  font-size: 14px;
  color: #666666;
}
.baseItem {
  width: 385px;
  label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
  }
  span {
    font-size: 14px;
    color: #000000;
    line-height: 22px;

  }
}
.pop-title {
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  font-weight: 700;
}
.el-dialog__wrapper /deep/ .assign-pop.el-dialog{
  background-color: rgb(243,243,243);
  .el-dialog__body{
    /* background-color: rgb(243,243,243); */
  }
  }
</style>
